import React, { PropsWithChildren } from "react";
import MaterialCard from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import css from "classnames";
import { Container, Grid, GridSpacing, Paper, Typography } from "@mui/material";
import styles from "./card.module.css";

type HTMLCardProps = React.DetailedHTMLProps<
React.HTMLAttributes<HTMLDivElement>,
HTMLDivElement>;

const elementHasCardContent = (element: any): boolean => {
  if (typeof element === "object" &&
  typeof element.type === "object" &&
  element.type.displayName?.includes("CardContent")) {
    return true;
  }
  return false;
};

const childrenHaveCardContent = (children?: any) => {
  if (children) {
    if (Array.isArray(children)) {
      return children.some(elementHasCardContent);
    } else if (elementHasCardContent(children)) {
      return true;
    }
  }
  return false;
};

export const Card: React.FC<HTMLCardProps &
{ref?: React.Ref<HTMLDivElement>, children?: any}> = ({
  children,
  className,
  ...attrs
}) => {
  if (childrenHaveCardContent(children)) {
    return (<MaterialCard {...attrs} className={css(className)}>
      {children}
    </MaterialCard>
    );
  }
  return (<MaterialCard {...attrs} className={css(className)}>
    <CardContent>{children}</CardContent>
  </MaterialCard>
  );
};

export const ContainerCard: React.FC<React.HTMLProps<HTMLDivElement>> = ({
  children,
  className,
  ...attrs
}) => (
  <div {...attrs} className={css(className, styles.containerCard)}>
    {children}
  </div>
);

// eslint-disable-next-line import/no-unused-modules
export const ContainerCardMaterial: React.FC<PropsWithChildren<{spacing?: GridSpacing}>> =
({ spacing = 4, children }) =>
  <Container maxWidth="xl" style={{ margin: "0 auto 50px" }} fixed>
    <div style={{ padding: 8 }}>
      <Paper>
        <div style={{ padding: 12 }}>
          <Grid container spacing={spacing}>
            {children}
          </Grid>
        </div>
      </Paper>
    </div>
  </Container>;

type ContainerCardProps = {
  title: React.ReactNode | string;
  subtitle?: React.ReactNode | string;
}
export const ContainerCardLayout: React.FC<PropsWithChildren<ContainerCardProps>> =
({ title, subtitle, children }) => (
  <ContainerCardMaterial>
    <Grid size={{ xs: 12, sm: 12 }}>
      {typeof title === "string" ? (<Typography variant="h5">{title}</Typography>) : title }
      {subtitle && typeof subtitle === "string" && (<Typography variant="subtitle2">{subtitle}</Typography>)}
      {subtitle && typeof subtitle !== "string" && subtitle}
      {children}
    </Grid>
  </ContainerCardMaterial>);
